export default __webpack_public_path__ + "static/media/tms-arge-mushroom4.4d2af109.webp";